/* ==========================================================================
   SearcherLeiPackages > accommodation
   ========================================================================== */

/* Modules */
const InputClient = require('@bluekiri/alexandria-contrib-components/components/input/client/js');
const UiPanelaccommodationClient = require('../../../ui-panel-accommodation-packages/client/js');
const config = require('./config');

/* Init */
function initAccommodation(selector, instance) {
    /* Instance reference with trigger and panel */
    const result = {};
    /* Input */
    result.trigger = InputClient(`${selector} ${config().accommodationTrigger.selector}`);
    result.trigger.setActive();

    /* Panel */
    result.panelAccommodation = UiPanelaccommodationClient(`${selector} ${config().accommodationPanel.selector}`, {
        type: config().getType('accommodationPanel'),
        panel: {
            hasClose: config().accommodationPanel.hasClose,
            triggers: [
                instance.element.querySelector(`${selector} [data-type="${config().getType('accommodationTrigger')}"]`)
            ],
            triggerInput: result.trigger
        }
    });

    return result;
}

module.exports = {
    initAccommodation
};
